import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

import App from './App';
import { LanguageProvider } from './i18n/LanguageProvider';
import { DirectionProvider } from './i18n/DirectionProvider';
import { CartProvider } from './store/cart';
import './main.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <DirectionProvider>
        <CssBaseline />
        <CartProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </CartProvider>
      </DirectionProvider>
    </LanguageProvider>
  </React.StrictMode>,
);
